export class ItemssubLotDto{
    sublotNumber:string
    lotNumber:string
    quantity:number
    opBoxes:number
    count?:number
    prodInvId ?: number
    constructor(
        sublotNumber:string,
        lotNumber:string,
        quantity:number,
        opBoxes:number,
        count?:number,
        prodInvId ?: number
    ){
        this.sublotNumber=sublotNumber;
        this.lotNumber=lotNumber;
        this.quantity=quantity;
        this.opBoxes=opBoxes;
        this.count = count;
        this.prodInvId = prodInvId
    }
     }